import { Fraction } from '../models';
import { getRequest } from '../services/requestHandler';

export const getFraction = async () => {
  const url = 'fraction?activeOnly=true';
  const response = await getRequest<Fraction>('GetFraction', url);
  return response;
};
